import { render, staticRenderFns } from "./scroll-to.vue?vue&type=template&id=28658b51&"
import script from "./scroll-to.vue?vue&type=script&lang=js&"
export * from "./scroll-to.vue?vue&type=script&lang=js&"
import style0 from "./scroll-to.vue?vue&type=style&index=0&id=28658b51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports